import { render, staticRenderFns } from "./Wap_ProductQRCode.vue?vue&type=template&id=0473257b&scoped=true&"
import script from "./Wap_ProductQRCode.vue?vue&type=script&lang=js&"
export * from "./Wap_ProductQRCode.vue?vue&type=script&lang=js&"
import style0 from "./Wap_ProductQRCode.vue?vue&type=style&index=0&id=0473257b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0473257b",
  null
  
)

export default component.exports